import React from 'react'

import Table from '../../../components/BPMTable/TableComponents/TableWrapper/SetupTableData'
import {ExportFooterItemCreator} from "../../../components/BPMTable/TableFooterItems"
import BayphoneDashboardTableCreator from '../../../tableDefinitions/Bayphone/BayphoneDashboardTableCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'


export default function BayphoneTable(props) {
    var tableCreatorCreator = tableCreatorCreatorFactoryCreator.getTableCreatorCreatorFromIdentifier(BayphoneDashboardTableCreator.getId(), {tcFilters: props.filters})
    tableCreatorCreator.setParentProps(props)
    const tableCreator = tableCreatorCreator.getTableCreator('Bayphone')
    tableCreator.setTableFooterItems([new ExportFooterItemCreator()]);

    return (
        <Table
            TableCreator={tableCreator}
        />
    )
}

